import React, { Component } from 'react'
import '../styles/ThemePicker.css'
import LAIcon from '../images/Themes/icon-la.png'
import VBNIcon from '../images/Themes/icon-vbn.png'
import AbattoirIcon from '../images/Themes/icon-abattoir.png'
import YakuzaIcon from '../images/Themes/icon-yakuza.png'
import TombeauIcon from '../images/Themes/icon-tombeau.png'
import LAIconDisabled from '../images/Themes/icon-disabled-la.png'
import VBNIconDisabled from '../images/Themes/icon-disabled-vbn.png'
import AbattoirIconDisabled from '../images/Themes/icon-disabled-abattoir.png'
import YakuzaIconDisabled from '../images/Themes/icon-disabled-yakuza.png'
import TombeauIconDisabled from '../images/Themes/icon-disabled-tombeau.png'
import ThemePickerItem from './ThemePickerItem'
import { injectIntl, defineMessages } from "react-intl"

class ThemePicker extends Component {

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <ul className="theme-picker">
        <ThemePickerItem
          id="all"
          title={formatMessage(messages.allRooms)}
          selected={this.props.selectedTheme}
          handleClick={() => this.props.handleChange("all")}
        />
        <ThemePickerItem
          singleTheme
          id="la"
          title={formatMessage(messages.la)}
          icon={LAIcon}
          iconDisabled={LAIconDisabled}
          selected={this.props.selectedTheme}
          handleClick={() => this.props.handleChange("la")}
        />
        <ThemePickerItem
          singleTheme
          id="vbn"
          title={formatMessage(messages.vbn)}
          icon={VBNIcon}
          iconDisabled={VBNIconDisabled}
          selected={this.props.selectedTheme}
          handleClick={() => this.props.handleChange("vbn")}
        />
        <ThemePickerItem
          singleTheme
          id="abattoir"
          title={formatMessage(messages.slaughterhouse)}
          icon={AbattoirIcon}
          iconDisabled={AbattoirIconDisabled}
          selected={this.props.selectedTheme}
          handleClick={() => this.props.handleChange("abattoir")}
        />
        <ThemePickerItem
          singleTheme
          id="yakuza"
          title={formatMessage(messages.yakuza)}
          icon={YakuzaIcon}
          iconDisabled={YakuzaIconDisabled}
          selected={this.props.selectedTheme}
          handleClick={() => this.props.handleChange("yakuza")}
        />
        <ThemePickerItem
          singleTheme
          id="tombeau"
          title={formatMessage(messages.titletombeau)}
          icon={TombeauIcon}
          iconDisabled={TombeauIconDisabled}
          selected={this.props.selectedTheme}
          handleClick={() => this.props.handleChange("tombeau")}
        />
      </ul>
    )
  }
}

const messages = defineMessages({
  allRooms: {
    id: 'themePicker.allRooms',
    defaultMessage: 'Toutes les salles'
  },
  la: {
    id: 'themes.la',
    defaultMessage: 'Toutes les salles'
  },
  vbn: {
    id: 'themes.VBN',
    defaultMessage: 'Toutes les salles'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: 'Toutes les salles'
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: 'Toutes les salles'
  },
  titletombeau: {
    id: 'themes.tombeau',
    defaultMessage: 'Expédition Maudite'
  }
})

export default injectIntl(ThemePicker)



// WEBPACK FOOTER //
// ./src/components/ThemePicker.js